function Component($http, AppConstants) {
	'ngInject';

	const service = {
		fetchDiscount: fetchDiscount,
		fetchDiscounts: fetchDiscounts,
		getDiscounts: getDiscounts,
		getDiscount: getDiscount,
		createDiscount: createDiscount,
		updateDiscount: updateDiscount,
		deleteDiscount: deleteDiscount
	};

	let discounts = [];
	let discount = {};

	return service;

	function fetchDiscounts(sort = '-id') {
		return $http.get(`${AppConstants.apiUrl}/discounts`, {
			'params': {sort}
		})
			.then(setDiscounts)
			.catch(failedRequest);
	}

	function fetchDiscount(id, relations = 'translations') {
		return $http.get(`${AppConstants.apiUrl}/discounts/${id}`, {
			'params': {
				'with': relations
			}
		})
			.then(setDiscount)
			.catch(failedRequest);
	}

	function setDiscounts(response) {
		discounts = response.data.data;

		return discounts;
	}

	function setDiscount(response) {
		discount = response.data.data;

		return discount;
	}

	function getDiscounts() {
		return discounts;
	}

	function getDiscount() {
		return discount;
	}

	function createDiscount(params) {
		return $http.post(`${AppConstants.apiUrl}/discounts`, params)
			.then(successRequest)
			.catch(failedRequest);
	}

	function updateDiscount(id, params) {
		return $http.put(`${AppConstants.apiUrl}/discounts/${id}`, params)
			.then(successRequest)
			.catch(failedRequest);
	}

	function deleteDiscount(id) {
		return $http.delete(`${AppConstants.apiUrl}/discounts/${id}`)
			.then(successRequest)
			.catch(failedRequest);
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		console.log(requestError);
		return requestError;
	}
}

export default Component;



/** WEBPACK FOOTER **
 ** ./client/components/discount/discount.service.js
 **/